export const colors = [
  'black',
  'black-lighter',
  'blue',
  'blue-dark',
  'blue-darker',
  'blue-lighter',
  'blue-lightest',
  'border-color',
  'gray',
  'gray-dark',
  'gray-darker',
  'gray-light',
  'gray-lighter',
  'green',
  'green-dark',
  'green-darker',
  'green-light',
  'green-lighter',
  'green-medium-lighter',
  'green-medium-lightest',
  'green-whatsapp',
  'helper-darken',
  'helper-darken-plus',
  'orange',
  'orange-dark',
  'orange-darker',
  'orange-light',
  'orange-lighter',
  'purple',
  'purple-light',
  'purple-lighter',
  'red',
  'red-dark',
  'red-darker',
  'red-light',
  'red-lighter',
  'red-medium-lighter',
  'red-medium-lightest',
  'white',
  'yellow',
  'yellow-light',
  'yellow-lighter',
] as const;

export type Color = typeof colors[number];

export const getColorValue = (color: Color): string => COLOR_VALUES[color] || '';
